<template>
    <a-tabs :animated="false" default-active-key="1">
        <a-tab-pane key="1">
            <span slot="tab"> {{ $t("settings.Chat") }} </span>
            <slot name="privateChatRepresentativeSlot"></slot>
        </a-tab-pane>
        <a-tab-pane key="2">
            <span slot="tab">
                {{ $t("message.representative") }}
            </span>
            <PrivateChatRepresentative />
        </a-tab-pane>
        <a-tab-pane key="3">
            <span slot="tab">
                {{ $t("message.settings") }}
            </span>
            <div class="ml-3 d-flex align-items-center">
                <label>{{ $t("message.privateChatNotificationSound") }}</label>
                <md-switch v-model="privateChatIsMutedComputed" class="md-primary ml-3">
                    <span v-if="!privateChatIsMuted">{{ $t("message.active") }}</span>
                    <span v-else>{{ $t("message.passive") }}</span>
                </md-switch>
            </div>
        </a-tab-pane>
    </a-tabs>
</template>
<script>
import PrivateChatRepresentative from "./PrivateChatRepresentative";
import { mapActions, mapState } from "vuex";

export default {
    name: "privateChatMenu",
    components: { PrivateChatRepresentative },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            privateChatIsMuted: (state) => state.app.privateChatIsMuted,
        }),

        privateChatIsMutedComputed: {
            get() {
                return this.privateChatIsMuted;
            },
            set() {
                this.togglePrivateChatIsMutedState();
            },
        },
    },
    methods: {
        ...mapActions({
            togglePrivateChatIsMutedState: "app/togglePrivateChatIsMutedState",
        }),
    },
};
</script>

<style scoped></style>
